/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';
import { HomePageComponentComponent } from '@src/app/pages/home-page-component/home-page-component.component';
import { AgentDashboardPageComponent } from '@src/app/modules/agent/agent-dashboard-page/agent-dashboard-page.component';
import { OmcDashboardComponent } from '@src/app/pages/omc-dashboard/omc-dashboard.component';

@Component({
    selector: 'app-dashboard-holder',
    imports: [HomePageComponentComponent, AgentDashboardPageComponent, OmcDashboardComponent],
    templateUrl: './dashboard-holder.component.html',
    styleUrl: './dashboard-holder.component.scss'
})
export class DashboardHolderComponent {
  currentUserSvc = inject(CurrentUserService);
  toggleOn = true; //window.location.host.startsWith('localhost');
}
